import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-wa-split-panel',
	templateUrl:'./WaSplitPanelPage.html',
	styles: [],
	styleUrls:['./WaSplitPanelPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class WaSplitPanelPage
{
	mdContent_456 = `\`\`\`java
import com.jwebmp.webawesome.components.splitpanel.WaSplitPanel;
\`\`\``;
	mdContent_457 = `\`\`\`java
var split = new WaSplitPanel<>();
split.setPosition(30);
split.add(leftPanel);
split.add(rightPanel);
\`\`\``;
}
